module.exports = __webpack_public_path__ + "static/media/iconMail.22e56bda.svg";